// extracted by mini-css-extract-plugin
export default {"result":"styles_result__7ffHb","icon":"styles_icon__HL-Es","title":"styles_title__jypUM"};